<hgroup>
  <h1>{{ data.header | translate }}</h1>
  <button
    appButton
    color="default"
    icon="close"
    iconPosition="only-icon"
    (click)="onReject()"></button>
</hgroup>

<main>
  @if (data.templateRef) {
    <ng-container
      [ngTemplateOutlet]="data.templateRef"
      [ngTemplateOutletContext]="{ $implicit: data.templateRefCtx }"></ng-container>
  } @else {
    <p class="p-3">{{ data.message | translate }}</p>
  }
</main>

<footer>
  <button
    appButton
    [shape]="'outlined'"
    (click)="onReject()">
    {{ data.rejectLabel ?? 'i18n.Global.cancel' | translate }}
  </button>
  <button
    appButton
    [color]="data.confirmColor ?? 'danger'"
    (click)="onConfirm()">
    {{ data.confirmLabel ?? 'i18n.Global.delete' | translate }}
  </button>
</footer>
